import { Play, Pause, Square, SkipForward } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TimerControlsProps {
  isRunning: boolean;
  onPlayPause: () => void;
  onReset: () => void;
  onSkip: () => void;
}

export const TimerControls = ({
  isRunning,
  onPlayPause,
  onReset,
  onSkip,
}: TimerControlsProps) => {
  return (
    <div className="flex justify-center gap-4">
      <Button
        variant="ghost"
        size="icon"
        onClick={onPlayPause}
        className="h-12 w-12 rounded-full hover:bg-white/10"
      >
        {isRunning ? (
          <Pause className="h-6 w-6 text-primary" />
        ) : (
          <Play className="h-6 w-6 text-primary" />
        )}
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={onReset}
        className="h-12 w-12 rounded-full hover:bg-white/10"
      >
        <Square className="h-6 w-6 text-primary" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={onSkip}
        className="h-12 w-12 rounded-full hover:bg-white/10"
      >
        <SkipForward className="h-6 w-6 text-primary" />
      </Button>
    </div>
  );
};